import { cn } from '../lib/cn.ts'
import { hint } from '../lib/hint.ts'
import { type LiveStatus, useLiveStatus } from '../lib/live.ts'

const META: Record<LiveStatus, { label: string; tip: string; dot: string }> = {
  live: {
    label: 'Live',
    tip: 'Live: changes from others appear within seconds',
    dot: 'bg-green-fg',
  },
  connecting: { label: 'Connecting…', tip: 'Connecting to live updates…', dot: 'bg-faint' },
  reconnecting: {
    label: 'Reconnecting…',
    tip: 'Reconnecting… changes will appear when the connection is back',
    dot: 'bg-amber-fg',
  },
  offline: {
    label: 'Offline',
    tip: 'Offline — changes will appear when you reconnect',
    dot: 'bg-faint',
  },
}

/** Top-bar sync dot (DESIGN.md §2): label hidden at ≤980px, dot only. */
export function LiveIndicator() {
  const status = useLiveStatus()
  const m = META[status]
  return (
    <span
      role="status"
      data-tour="live-dot"
      aria-label={m.tip}
      className="inline-flex h-8 items-center gap-1.5 rounded-ctl px-1.5 text-[12.5px] text-muted"
      {...hint(m.tip)}
    >
      <span
        aria-hidden
        className={cn(
          'size-2 shrink-0 rounded-full',
          m.dot,
          status === 'reconnecting' && 'motion-safe:animate-pulse',
        )}
      />
      <span aria-hidden className="max-[980px]:hidden">
        {m.label}
      </span>
    </span>
  )
}
